import React, { useState } from "react";
import { Activity, AlertTriangle, Loader2, Play } from "lucide-react";
import ActiveCardShell from "../ActiveCardShell";
import { sleep, RunButton, useAlive } from "../phase2/shared";

const CAP = 250000;
const DAILY = [9800, 11200, 10400, 12100, 11800, 13500, 12900, 14200, 13100, 15800, 48600, 22400, 16900, 14700];

export default function MidMonitorCard({ merchant }) {
  const [days, setDays] = useState(0);
  const [adjusted, setAdjusted] = useState(false);
  const [running, setRunning] = useState(false);
  const alive = useAlive();

  const run = async () => {
    setRunning(true); setDays(0); setAdjusted(false);
    for (let i = 1; i <= DAILY.length; i += 1) { await sleep(230); if (!alive.current) return; setDays(i); }
    await sleep(900);
    if (!alive.current) return;
    setAdjusted(true);
    setRunning(false);
  };

  const used = DAILY.slice(0, days).reduce((a, b) => a + b, 0);
  const pct = Math.round((used / CAP) * 100);
  const warn = pct >= 90;
  const max = Math.max(...DAILY);
  return (
    <ActiveCardShell id="T3100cr" kicker="PORTFOLIO RISK" title="MID Monitoring & Volume Tracking" Icon={Activity}
      actions={<RunButton tid="veroogle-t3100-run" running={running} onClick={run} Icon={running ? Loader2 : Play} label="Stream volume" />}>
      <div className="flex items-center justify-between font-mono text-[10px] tracking-[0.18em] uppercase text-slate-400 mb-2">
        <span>MID · {merchant.name}</span>
        <span className={warn ? "text-amber-300" : "text-brand-cyan"} data-testid="veroogle-t3100-pct">{pct}% of ${adjusted ? "300k" : "250k"} cap</span>
      </div>
      <div className="h-32 flex items-end gap-1.5 rounded-lg border border-white/10 bg-navy-950/40 p-3">
        {DAILY.map((v, i) => (
          <div key={i} className="flex-1 rounded-t transition-[height,opacity] duration-300"
            style={{ height: i < days ? `${(v / max) * 100}%` : "4%", opacity: i < days ? 1 : 0.15,
              background: v > 30000 ? "linear-gradient(#f59e0b,#f43f5e)" : "linear-gradient(#22d3ee,#10b981)" }} />
        ))}
      </div>
      <div className="mt-3 flex flex-wrap gap-2 min-h-[34px]">
        {warn && (
          <span data-testid="veroogle-t3100-alert" className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg border border-amber-400/50 bg-amber-500/10 text-amber-200 text-xs animate-in fade-in zoom-in-95">
            <AlertTriangle className="w-3.5 h-3.5" /> Cap warning · velocity spike on day 11
          </span>
        )}
        {adjusted && (
          <span data-testid="veroogle-t3100-limit" className="inline-flex items-center px-3 py-1.5 rounded-lg border border-emerald-400/40 bg-emerald-500/10 text-emerald-200 text-xs animate-in fade-in">
            Limit auto-adjusted to $300,000 / mo
          </span>
        )}
      </div>
    </ActiveCardShell>
  );
}
